import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

export const LF_ID_RX = /^\s*(?:id\s*[:#]?\s*)?#?\s*(?:[A-Za-z]{2}\s*-?\s*)?\d{6,7}\s*$/i;

export const CopyIdButton = ({ listing, fr }) => {
  const [done, setDone] = useState(false);
  if (listing?.category !== "lost-found" || !listing.lf_id) return null;
  const copy = async () => {
    const text = `${listing.title} · ID ${listing.lf_id} · ${window.location.origin}/listing/${listing.id}`;
    try { await navigator.clipboard.writeText(text); } catch {
      const ta = Object.assign(document.createElement("textarea"), { value: text });
      document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    setDone(true);
    toast.success(fr ? "ID copié — collez-le dans un texto ou un courriel" : "ID copied — paste it in a text or email");
    setTimeout(() => setDone(false), 2000);
  };
  return (
    <button type="button" onClick={copy} data-testid="copy-lf-id-btn"
      className="inline-flex items-center gap-1 h-7 px-2.5 rounded-md border border-slate-200 text-xs font-semibold text-[#12234A] hover:border-[#F5551E] hover:text-[#F5551E] transition-colors">
      {done ? <Check size={13} className="text-emerald-600" /> : <Copy size={13} />} {fr ? "Copier l'ID" : "Copy ID"}
    </button>
  );
};

export const LostFoundId = ({ listing, size = "sm", testid }) => {
  if (listing?.category !== "lost-found" || !listing.lf_id) return null;
  const big = size === "lg";
  return (
    <span data-testid={testid || `lf-id-${listing.id}`} title="Lost & Found ID — quote it when you call or message"
      className={`inline-flex items-center gap-1 rounded-md bg-[#12234A] text-white font-mono font-bold tracking-wide shrink-0 ${big ? "text-sm px-2.5 py-1" : "text-[11px] px-1.5 py-0.5"}`}>
      <span className="text-[#F5551E]">ID</span>{listing.lf_id}
    </span>
  );
};
